const pageNameKey = "ticketsPage";

export const ticketsPageEn = {
  [pageNameKey]: {
    inboxTitle: "Inbox",
    refreshText: "Refresh",
    errorFetchingTickets: "Error fetching tickets",
  },
};

export const ticketsPagePtBr = {
  [pageNameKey]: {
    inboxTitle: "Caixa de entrada",
    refreshText: "Atualizar",
    errorFetchingTickets: "Erro ao buscar tickets",
  },
};

export const ticketsPageDe = {
  [pageNameKey]: {
    inboxTitle: "Posteingang",
    refreshText: "Aktualisieren",
    errorFetchingTickets: "Fehler beim Abrufen der Tickets",
  },
};

export const ticketsPageZhHans = {
  [pageNameKey]: {
    inboxTitle: "收件箱",
    refreshText: "刷新",
    errorFetchingTickets: "获取工单时出错",
  },
};

export const ticketsPageIt = {
  [pageNameKey]: {
    inboxTitle: "Posta in arrivo",
    refreshText: "Aggiorna",
    errorFetchingTickets: "Errore durante il recupero dei ticket",
  },
};

export const ticketsPageEs = {
  [pageNameKey]: {
    inboxTitle: "Bandeja de entrada",
    refreshText: "Actualizar",
    errorFetchingTickets: "Error al obtener los tickets",
  },
};

export const ticketsPageNl = {
  [pageNameKey]: {
    errorFetchingTickets: "Fout bij het ophalen van tickets",
    inboxTitle: "Inbox",
    refreshText: "Bijwerken",
  },
};

export const ticketsPageTr = {
  [pageNameKey]: {
    errorFetchingTickets: "Biletler alınırken hata oluştu",
    inboxTitle: "Gelen kutusu",
    refreshText: "Yenile",
  },
};
